const RAW_TILES_SOURCE_ID = 'rawTilesSource';

const source = {
  id: RAW_TILES_SOURCE_ID,
  data: `cartodb-gcp-solutions-eng-team.telus_alberta.polys_2100_rsrp_z12`,
  type: 'bq',
};

export default source;
